import { useSelector } from './use-selector.js';
import { PieChartState } from '../../types/state.js';

export const useTooltipState = () =>
  useSelector((state: PieChartState) => state.tooltip);

export const useTooltipContent = () =>
  useSelector((state: PieChartState) => state.tooltip.content);

export const useTooltipPinnedStatus = () =>
  useSelector((state: PieChartState) => state.tooltip.pinned);

export const useTooltipPosition = () =>
  useSelector((state: PieChartState) => state.tooltip.position);

export const useTooltipVisibility = () =>
  useSelector((state: PieChartState) => state.tooltip.visible);

export const useOverlayState = () =>
  useSelector((state: PieChartState) => state.overlay);

export const useHighlightedIdsState = () =>
  useSelector((state: PieChartState) => state.highlightedIds);

export const useVisibleSlicesState = () =>
  useSelector((state: PieChartState) => state.visibleSlices);
